import { Seo } from "@/components/Seo";
import { Hero } from "@/sections/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/sections/About";
import { Services } from "@/sections/Services";
import { Equipment } from "@/sections/Equipment";
import { WhyChoose } from "@/sections/WhyChoose";
import { HowItWorks } from "@/sections/HowItWorks";
import { FaqSection } from "@/sections/FaqSection";
import { CtaBand } from "@/sections/CtaBand";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Seo
        title="B&H Truck Dispatching | Truck Dispatch Services for Owner-Operators"
        description="B&H Truck Dispatching provides professional truck dispatching, load planning, rate negotiation and carrier support for owner-operators and fleets."
      />
      <Hero />
      <Marquee />
      <About />
      <Services />
      <Equipment />
      <WhyChoose />
      <HowItWorks />
      <FaqSection />
      <CtaBand />
    </main>
  );
}
